// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentCard_root__QOL8X","card":"PaymentCard_card__32QZ_","mask":"PaymentCard_mask__1sEoQ","icon":"PaymentCard_icon__2Kvu5"};